define('shared/initializer/form/adapters/DirectDebitPayment',[
    '$',
    '../constants',
    './Payment',
    'shared/lib/ctor',
    'shared/lib/RSVP',
    'shared/util/checkout/directdebit',
    'shared/lib/console',
    'shared/util/state',
    'kernel/ui/Blocker',
    './mixins/Returnable',
    './mixins/upsell/CardPayment'
    ],
function (
    $,
    constants,
    Payment,
    ctor,
    RSVP,
    ddUtil,
    console,
    state,
    BlockerUI,
    Returnable,
    UpsellCardPayment
) {
    'use strict';

    var Ctor = ctor(function() {
        var me = this;
        me.base.apply(me, arguments);
        me.prefillable = {
            fields: {
                fullName: constants.FIELD.dcInfoAccountName
            }
        };
        me.mixin(
            UpsellCardPayment,
            Returnable
        );
    }).inherit(Payment);

    var p = Ctor.prototype;

    function removeSpacesAfterBlur($el){
        $el.blur(function(){
            var origin = $el.val();
            if(!origin) return;

            $el.val(origin.split(' ').join(''));
        });
    }

    p.doPageLoad = function(){
        var me = this;

        var bankCode = me.items.get(constants.FIELD.DebitCardBankCode);
        var accountNumber = me.items.get(constants.FIELD.DebitCardAccountNumber);

        if(bankCode && bankCode.$el && bankCode.$el.length > 0){
            removeSpacesAfterBlur(bankCode.$el);
        }

        if(accountNumber && accountNumber.$el && accountNumber.$el.length > 0){
            removeSpacesAfterBlur(accountNumber.$el);
        }

        var basePromise = Payment.prototype.doPageLoad.apply(me, arguments);

        return basePromise
        .then(function(){
            var mandateLightBoxId = me.$form.prop('id') + '-directdebit-lightbox';
            me.$mandateLightBox = $('#' + mandateLightBoxId);

            if (typeof me.$mandateLightBox.modal !== 'function') {                            
                me.$mandateLightBox.hide();
            }

            return RSVP.all([
                ddUtil.getMandateId(),
                ddUtil.getMandateDate()
            ]);
        })
        .then(function(values){
            me.$form.find('[name="' + constants.FIELD.dcInfoMandateId + '"]').val(values[0]);
            me.$form.find('[name="' + constants.FIELD.dcInfoMandateDate + '"]').val(values[1]);
        });
    };

    function getCurrentDate(rawMandateDate){
        var today = rawMandateDate;
        var dd = today.getDate();
        if(dd < 10){
            dd= '0' + dd;
        }

        var mm = today.getMonth() + 1;
        if(mm < 10){
            mm= '0' + mm;
        }

        var yyyy = today.getFullYear();
        return yyyy + '-' + mm + '-' + dd;
    }

    p.doBeforeSubmit = function(){
        var me = this;
        var basePromise = Payment.prototype.doBeforeSubmit.apply(me, arguments);
        var offerIsOneOff = false;
        var rawMandateDate = null;


        return ddUtil.getRawMandateDate()
            .then(function(rawDate){
                rawMandateDate = rawDate;
            })
            .then(function(){
                return state.get('order');
            })
            .then(function(values){
                var order = values[0];
                offerIsOneOff = ddUtil.isOneOffOrder(order);
            })
            .then(function(){
                return basePromise.then(function(){
                    return new RSVP.Promise(function(resolve, reject){

                        if (typeof me.$mandateLightBox.modal !== 'function') {
                            resolve();
                            return;
                        }

                        me.$mandateLightBox.find('.data-date').text(getCurrentDate(rawMandateDate));
                        me.$mandateLightBox.find('.data-iban').text(me.$form.find('[name="dcInfo.AccountNumber"]').val());
                        me.$mandateLightBox.find('.data-bic').text(me.$form.find('[name="dcInfo.BankCode"]').val());
                        me.$mandateLightBox.find('.data-name').text(me.$form.find('[name="dcInfo.AccountName"]').val());
                        me.$mandateLightBox.find('.data-address').text(me.$form.find('[name="dcInfo.CustomerAddress"]').val());
                        var $typeOfPayment = me.$mandateLightBox.find('.type-of-payment');
                        $typeOfPayment.text(offerIsOneOff ? $typeOfPayment.attr('data-oneoff-payment') : $typeOfPayment.attr('data-recurring-payment'));

                        me.$lightboxConfirmButton = me.$mandateLightBox.find('.confirm-button');
                        me.$lightboxConfirmButton.one('click', function(){
                            console.log('confirmed, moving on....');
                            me.uiBlocker = new BlockerUI(me.$lightboxConfirmButton[0]);
                            me.uiBlocker.block();
                            resolve();
                        });
                        me.$mandateLightBox.find('.change-detail-button').one('click', function(){
                            console.log('submit cancelled, rejecting.....');
                            me.enable();
                            var err = new Error('submit cancelled by user');
                            err.abort = true;

                            reject(err);
                        });

                        me.$mandateLightBox.modal();
                    });

                });
            });
    };

    p.doSubmitFail = function(reason) {
        var me = this;
        if(me.$mandateLightBox && typeof me.$mandateLightBox.modal === 'function'){
            me.$mandateLightBox.modal('hide');
        }

        if(me.uiBlocker){
            me.uiBlocker.resume();
        }

        return RSVP.resolve(reason);
    };

    return Ctor;
});

